import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';
import { Helmet } from 'react-helmet';
import { Elements } from 'react-stripe-elements';

import SignupForm from './SignupForm';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  data: PropTypes.object,
};

const defaultProps = {
  data: null,
};

class Signup extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(payload) {
    this.props.onSubmit(payload);
  }

  render() {
    const { data } = this.props;

    if (data) {
      const { first_name } = data;

      return (
        <Alert className="Signup__alert">
          <h4 className="alert-heading">Congrats, {first_name}!</h4>

          <div>
            Your account has been created.
            To activate it, please follow the instructions in the email we just sent you.
          </div>
        </Alert>
      );
    }

    return (
      <div className="Signup">
        <Helmet title="Signup" />

        <div className="Signup__header">
          <h3>Create an Account</h3>
          <span>
            Enjoy a free 30-day trial.
          </span>
        </div>

        <Elements>
          <SignupForm
            onSubmit={this.handleSubmit}
          />
        </Elements>
      </div>
    );
  }
}

Signup.propTypes = propTypes;
Signup.defaultProps = defaultProps;

export default Signup;



// WEBPACK FOOTER //
// ./src/features/Signup/Signup.js